<div class="virtual-event" [ngClass]="classname">
  <div class="mt-3">
    <app-layout name="header">
      <div class="virtual-event__header">
        <div class="col-12">
          <div class="row">
            <div class="col-6">
              <div class="page__name">Virtual Event</div>
              <ng-container *ngIf="event$ | async as event">
                <div class="virtual-event__name">{{event.name}}</div>
              </ng-container>
            </div>
            <div class="col-6 d-flex align-items-center justify-content-end">
              <div class="mr-2">
                <mdb-form-control class="form-select form-fill event-select" [ngClass]="selectClassOne">
                  <mdb-select class="mdb-select mdb-select--hidden-input" (valueChange)="onSelectMode($event)" (opened)="addClass(1)" (closed)="removeClass(1)" (click)="onClickSelect($event, selectMode)" #selectMode>
                    <mdb-option *ngFor="let option of modeList" [value]="option" class="select-option">{{option.label}}</mdb-option>
                    <div class="select-custom-content d-none"></div>
                  </mdb-select>
                  <label mdbLabel class="form-label dropdown-label">{{getSelectedModeLabel()}}</label>
                </mdb-form-control>
              </div>
  
              <div class="mr-2">
                <mdb-form-control class="form-select form-fill event-select" [ngClass]="selectClassTwo">
                  <mdb-select class="mdb-select mdb-select--hidden-input" (valueChange)="onSelect($event)"(opened)="addClass(2)" (closed)="removeClass(2)" (click)="onClickSelect($event, select)" #select>
                    <mdb-option *ngFor="let option of list" [value]="option" class="select-option">{{option.label}}</mdb-option>
                    <div class="select-custom-content d-none"></div>
                  </mdb-select>
                  <label mdbLabel class="form-label dropdown-label">{{getDropdownToggleLabel()}}</label>
                </mdb-form-control>
              </div>
         
            </div>
          </div>
        </div>
      </div>
    </app-layout>
    <ng-container *ngIf="showRegularMode; else showAuctioneerMode" >
      <div class="virtual-event__content">
        <div class="col-12">
          <div class="row">
            <app-layout class="col-sm-12 col-md-3 col-lg-3 col-xl-3" name="status">
              <app-widget widget="virtual-event-status">
                <app-status class="widget__content"></app-status>
              </app-widget>
            </app-layout>
            <app-layout class="col-sm-12 col-md-3 col-lg-3 col-xl-3" name="time-elapsed">
              <app-widget widget="time-elapsed" type="regular">
                <app-time-elapsed class="widget__content"></app-time-elapsed>
              </app-widget>
            </app-layout>
            <app-layout class="col-sm-12 col-md-3 col-lg-3 col-xl-3" name="goal">
              <app-widget widget="goal" type="regular">
                <app-goal class="widget__content"></app-goal>
              </app-widget>
            </app-layout>
            <app-layout class="col-sm-12 col-md-3 col-lg-3 col-xl-3" name="users">
              <app-widget widget="users" type="regular">
                <app-users class="widget__content"></app-users>
              </app-widget>
            </app-layout>
          </div>
        </div>
        <div class="col-12">
          <div class="row">
            <app-layout class="col-sm-12 col-md-6 col-lg-6 col-xl-6" name="playlist">
              <app-widget widget="playlist">
                <div
                  class="d-flex align-items-center justify-content-start widget__title widget__title--playlist widget__header--left-side"
                >Playlist</div>
                <div class="d-flex justify-content-end widget__header--right-side">
                  <app-campaign-list class="w-100" [theme]="theme"></app-campaign-list>
                </div>
                <app-playlist class="widget__content"></app-playlist>
              </app-widget>
            </app-layout>
            <div class="col-sm-12 col-md-6 col-lg-6 col-xl-6">
              <div class="row">
                <app-layout class="col-sm-12 col-md-12 col-lg-12 col-xl-12" name="live">
                  <app-widget widget="currently-live">
                    <div class="d-flex align-items-center justify-content-start widget__title widget__header--left-side">
                      <span class="mr-2">Now Live</span>
                      <button
                        class="btn btn--paybee btn--primary btn--xs mr-2"
                        (click)="onClear('', { id: '', name: 'Event Info and Sponsors' }, true)"
                      >Clear</button>
                    </div>
                    <div class="d-flex align-items-center justify-content-end widget__title widget__header--right-side">
                      <ng-container *ngIf="event$ | async as event">
                        <div *ngIf="event.runStatus === 1" [ngSwitch]="event.currentItem.presentationMode" class="d-flex justify-content-center">
                          <button *ngSwitchCase="0" class="btn btn--paybee btn--success btn--xs ml-2" (click)="onSetPresentationMode(1)">Enter Full Screen Video</button>
                          <button *ngSwitchCase="1" class="btn btn--paybee btn-danger btn--xs ml-2" (click)="onSetPresentationMode(0)">Exit Full Screen Video</button>
                        </div>
                      </ng-container>
                    </div>
                    <div class="widget__content">
                      <app-currently-live-campaign></app-currently-live-campaign>
                      <app-currently-live-option></app-currently-live-option>
                    </div>
                  </app-widget>
                </app-layout>
                <app-layout class="col-sm-12 col-md-12 col-lg-12 col-xl-12" name="activity">
                  <app-widget widget="activity">
                    <div class="widget__title widget__header--left-side">Activity</div>
                    <app-activity-list class="widget__content"></app-activity-list>
                  </app-widget>
                </app-layout>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  
    <ng-template #showAuctioneerMode>
      <div class="virtual-event-auctioneer-content">
        <div class="col-12">
          <div class="row">
            <app-layout class="col-12 col-sm-12 col-md-12 col-lg-5" name="campaign-info">
              <app-current-campaign-info></app-current-campaign-info>
            </app-layout>
  
            <app-layout class="col-12 col-sm-12 col-md-12 col-lg-7" name="recent-acitivities">
              <app-recent-activities [type]="selected.name"></app-recent-activities>
            </app-layout>
  
          </div>
        </div>
      </div>
    </ng-template>
  
    <ng-container *ngIf="chatStatus$ | async as chatStatus">
      <app-chat *ngIf="chatStatus === 'opened'"></app-chat>
    </ng-container>
    <app-chat-button></app-chat-button>
  </div>
</div>

